import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';
import { black, orange, porcelain, scienceBlue } from '../../../abstracts/colours';

interface Props {
  noBackground: boolean;
}

export const StyledProgressBarContainer = styled.div`
  text-align: right;
`;

export const StyledLabel = styled.label`
  object-fit: contain;
  opacity: 0.6;
  font-family: SourceSansPro;
  font-size: 14px;
  color: ${black};
`;

const useStyles = makeStyles({
  root: {
    height: 16,
    borderRadius: 9,
    marginTop: 8,
  },
  bar: {
    borderRadius: 9,
  },
  colorPrimary: {
    backgroundColor: (props: Props): string => (props.noBackground ? porcelain : `${scienceBlue}1A`),
  },
  barColorPrimary: {
    backgroundColor: scienceBlue,
  },
  colorSecondary: {
    backgroundColor: (props: Props): string => (props.noBackground ? porcelain : `${orange}1A`),
  },
  barColorSecondary: {
    backgroundColor: orange,
  },
});

export default useStyles;
